export default __webpack_public_path__ + "static/media/Charity App.7ad0a3fb.png";